module.exports = __webpack_public_path__ + "static/power-up-your-brain-698dc0b4332f821274743857c55c255f.jpg";